import { post, get } from "src/services/api";

export const sharePreview = async ({ params, payload }) => {
  try {
    return await post({ endpoint: `/accounts/${params.accountId}/assistants/${params.assistantId}/preview/share`, data: payload });
  }
  catch (error) {
    console.error(error);
    throw new Error();
  }
};

export const getPreviewLink = async (params) => {
  try {
    return await get({ endpoint: `/accounts/${params.accountId}/assistants/${params.assistantId}/preview/link`, params: { branchName: params.branchName } });
  }
  catch (error) {
    console.error(error);
    throw new Error();
  }
};
